// The two calls behind padelr.app/coach. Neither needs a session.
//
// A coach that does not exist - or a user who is not a coach, which the
// server answers identically - comes back as a 404 and resolves to null here,
// so the page can say so rather than spin.

async function post(path, body) {
    const res = await fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    })
    if (res.status === 404) return null
    if (!res.ok) throw new Error(`${path}: ${res.status}`)
    return res.json()
}

export function listCoaches(search, token) {
    return post('/api/v1/coach/public/list', { search: search || '', token: token || '' })
}

export function readCoach(username) {
    return post('/api/v1/coach/public/read', { username })
}
